import { useEffect, useState } from "react";
import FadeIn from "../../../src/vendored/FadeIn";
import { useHistory } from "react-router-dom";
import { GuildData, GuildSelectProps } from "../../../common/sesh_types";
import { DashboardUtils, FADE_IN_ANIMATION_DURATION } from "./dashboard_utils";
import {
	SeshSearchForm,
	SeshTextSearchInput,
} from "./forms/improved_components/base_components/sesh_search_form";
import { useDocTitle } from "./forms/improved_components/hooks/use_doc_title";

function open_invite_screen(guild_data: GuildData, client_id: string) {
	let redirect_uri = location.protocol + "//" + location.host + "/dashboard";

	window.open(
		`https://discord.com/oauth2/authorize?client_id=${client_id}&permissions=17998396517440&guild_id=${guild_data.id}&scope=applications.commands%20bot&response_type=code&redirect_uri=${redirect_uri}`,
		"_self"
	);
}

function RenderGuildIcon(props: {
	guild_data: GuildData;
	bot_client_id: string;
}) {
	const data = props.guild_data;
	const client_id = props.bot_client_id;
	let uri = DashboardUtils.GetGuildIconURI(data, 128);

	const history = useHistory();

	const classNames =
		"column is-narrow is-centered has-text-centered guild-icon-container";
	let img_class = "guild-icon is-rounded has-text-centered";
	let figure_class =
		"cursor-pointer image is-96x96 is-inline-block guild-icon-figure";
	let guild_name_class = "guild-name-text";
	let on_click_func: Function;
	if (!data.has_sesh) {
		img_class += " uninvited-guild-icon grayed-out-image";
		guild_name_class += " grayed-out-image";
		on_click_func = (data) => open_invite_screen(data, client_id);
	} else {
		on_click_func = (data) => history.push(`${data.id}`);
		if (data.is_premium) {
			guild_name_class += " gold-color";
		}
	}

	let guild_name = DashboardUtils.LimitGuildName(data.name);

	return (
		<div key={data.id} className={classNames}>
			<span className="tooltip">
				<figure
					className={figure_class}
					onClick={() => on_click_func(data)}
				>
					<img className={img_class} src={uri} />
					<p className={guild_name_class}>{guild_name}</p>
					{data.is_premium && data.has_sesh && (
						<span className="premium-tooltiptop gold-color">
							{data.has_sesh_pro ? "✨ sesh Pro ✨" : "👑 Premium 👑"}
						</span>
					)}
				</figure>
			</span>
		</div>
	);
}

export function GuildSelectForm(props: GuildSelectProps) {
	const [searchString, setSearchString] = useState("");

	useDocTitle("Server select");

	const guilds = props.list_of_guilds.filter((val) =>
		val.name.toLowerCase().includes(searchString.toLowerCase())
	);

	return (
		<FadeIn transitionDuration={FADE_IN_ANIMATION_DURATION}>
			<div
				className="columns is-mobile is-centered"
				style={{ transition: "opacity 0s", opacity: "1" }}
			>
				<div
					className={
						"column is-11-mobile is-10-tablet is-half-widescreen is-three-fifths-fullhd create-event-container"
					}
				>
					<h1 className="title is-3 has-text-centered !mb-8">
						<i className="fab fa-discord fa-lg title-icon"></i>
						Select Server
					</h1>
					<div className="flex flex-col gap-4">
						<SeshTextSearchInput
							handleChange={(val) => setSearchString(val)}
							handleClear={() => setSearchString("")}
							input_props={{
								className: "w-64 ml-auto",
								value: searchString,
								placeholder: "Search",
							}}
							onSubmit={() => {}}
						/>
						<div className="columns is-multiline is-mobile is-centered">
							{guilds.map((val) => (
								<RenderGuildIcon
									key={val.id}
									guild_data={val}
									bot_client_id={props.bot_client_id}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		</FadeIn>
	);
}
